import {
  Grid,
  Button,
  Box,
  TextField,
  FormControl,
  FormHelperText,
  Typography,
} from "@mui/material";
import React, { memo, useEffect, useState } from "react";
import ButtonRight from "../../components/BoxRightContent/ButtonRight";
import BoxLeftContent from "../../components/BoxLeftContent/BoxLeftContent";
import clsx from "clsx";
import { checkIdcard } from "../../utils/formatter";
import Configs from "../../constants/Configs";
import DialogCustoms from "../../components/CustomDialog/DialogCustoms";
import DialogCustom from "../../components/CustomDialog/DialogCustoms";
import DialogError from "../../components/CustomDialog/DialogWait";
import GlobalApi from "../../utils/GlobalApi";
import {
  clearData,
  getData,
  storeData,
  checkDipChipStatus,
} from "../../utils/GlobalHelper";
import HeaderRight from "../../components/BoxRightContent/HeaderRight";
import HeaderPage from "../../components/HeaderPage/Index";
import { isEmpty, isNil } from "lodash";
import { isAndroid, isMobile } from "react-device-detect";
import Loading from "../../components/loading/loading";
import qs from "qs";
import { makeStyles } from "@mui/styles";
import ScrollBarComponent from "../../components/BoxRightContent/ScrollBarComponent";

import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import "./CheckUserInfo.css";
import moment from "moment";
const useStyle = makeStyles({
  textPhone: {
    paddingRight: "5px",
    color: "var(--text-black)",
  },
  title_row: {
    color: "var(--primary)",
    fontFamily: "DB Heavent",
    marginTop: "25px",
    fontSize: "24px",
    // fontWeight: "700",
  },
  textError: {
    fontSize: "16px !important",
    fontFamily: "DB Heavent !important",
    color: "var(--red) !important",
  },
});
const CheckUserInfo = (props) => {
  const header = {
    headers: {
      Accept: "application/json",
    },
  };
  const classes = useStyle();
  const [errorValidateText, setErrorVaildateText] = React.useState({
    cardId: "",
    aeCode: "",
    f0_mobile_phone: "",
    f0_email: "",
    f0_email_1: "",
  });
  const [value, setValue] = useState();
  const [haveAeCode, setHaveAeCode] = useState(true);
  const [isCheck, setIscheck] = useState(false);
  const [isCheckIdcard, setIscheckIdcard] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [isModalError, setIsModalError] = useState(false);
  const [isModalHaveAccount, setIsModalHaveAccount] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const [lang, setLang] = useState(getData("lang"));
  const [modalErrorTitle, setModalErrorTitle] = useState("ขออภัย");
  const [modalErrorDes, setModalErrorDes] = useState(
    "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง",
  );
  const [translations, setTranslations] = useState("");
  const [dipChip, setDipChip] = useState("");
  useEffect(() => {
    const checkuserinfo = getData("checkuserinfo");
    const translation = getData("Translations");
    if (!isEmpty(translation)) {
      setTranslations(translation);
    } else {
      props.history.push("/");
    }
    if (!isEmpty(checkuserinfo)) {
      setCardId(formatCid(checkuserinfo.cardId));
      if (checkuserinfo.aeCode) {
        setAeCode(checkuserinfo.aeCode);
        setHaveAeCode(true);
      }
      setMobilePhone(checkuserinfo.f0_mobile_phone);
      setEmail(checkuserinfo.f0_email);
      setEmail1(checkuserinfo.f0_email_1);
      checkDipchip(checkuserinfo.cardId);
    } else {
      const aecode = getData("aecode") ? getData("aecode") : "";
      if (aecode !== "") {
        setAeCode(aecode);
        setHaveAeCode(true);
      }
    }
  }, []);
  const [cardId, setCardId] = useState("");
  const [cardIdError, setCardIdError] = useState("");
  const cardIdChange = async (val) => {
    val = val.replace(/[-]+/g, "").slice(0, 13);
    let isnum = /^\d+$/.test(val);
    if (val.length == 13 && isnum) {
      val = formatCid(val);
      checkCid(val);
      setCardId(val.replace(/[^0-9-]+/g, ""));
      if (checkCid(val)) {
        checkDipchip(val);
      }
    } else {
      setIscheckIdcard(false);
      setCardId(val.replace(/[^0-9-]+/g, ""));
    }
    if (isSubmit) {
      await setCardIdError("");
      if (!isEmpty(val)) {
        if (!checkCid(val)) {
          setCardIdError("กรุณาระบุเลขที่บัตรประจำตัวประชาชนให้ถูกต้อง");
        }
      } else {
        setCardIdError("กรุณาระบุเลขที่บัตรประจำตัวประชาชน");
      }
    }
  };
  const [aeCode, setAeCode] = useState("");
  const [aeCodeError, setAeCodeError] = useState("");
  const aeCodeChange = async (val) => {
    val = val.replace(/[^A-Za-z0-9]/g, "");
    setAeCode(val);
    setAeCodeError("");
    if (!isEmpty(val)) {
      if (val.length > 0 && val.length < 4) {
        setAeCodeError("กรุณาระบุ AE CODE  ให้ครบ 4 หลัก");
      } else {
        setAeCodeError("");
      }
    }
  };
  const [f0_mobile_phone, setMobilePhone] = useState("");
  const [mobilePhoneError, setMobilePhoneError] = useState("");
  const mobilePhoneChange = async (val) => {
    val = val.replace(/[-]+/g, "");
    setMobilePhone(val.replace(/[^0-9-]+/g, ""));
    if (isSubmit) {
      setMobilePhoneError("");
      if (isEmpty(val) || val.length < 10) {
        setMobilePhoneError("กรุณาระบุเบอร์โทรศัพท์มือถือ");
      }
    }
  };
  const [f0_email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const emailChange = async (val) => {
    val = val.replace(/[^A-Za-z0-9@_\-\.]/g, "");
    setEmail(val);
    if (isSubmit) {
      setEmailError("");
      if (isEmpty(val)) {
        setEmailError("กรุณาระบุอีเมล");
      } else {
        if (!val.match(mailformat)) {
          setEmailError("กรุณาระบุอีเมลให้ถูกต้อง");
        } else {
          setEmailError("");
        }
      }
    }
  };
  const mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
  const [f0_email_1, setEmail1] = useState("");
  const [emailError1, setEmailError1] = useState("");
  const emailChange1 = async (val) => {
    val = val.replace(/[^A-Za-z0-9@_\-\.]/g, "");
    if (isSubmit) {
      setEmailError1("");
      if (isEmpty(val)) {
        setEmailError1("กรุณาระบุยืนยันอีเมล");
      } else {
        if (!val.match(mailformat)) {
          setEmailError1("กรุณาระบุยืนยันอีเมลให้ถูกต้อง");
        } else {
          if (f0_email !== val) {
            setEmailError1("อีเมลไม่ตรงกัน โปรดตรวจสอบอีเมล");
          } else {
            setEmailError1("");
          }
        }
      }
    }
    setEmail1(val);
  };
  const checkCid = (cid) => {
    var total = 0;
    var iPID;
    var chk;
    var Validchk;
    iPID = cid.replace(/-/g, "");
    Validchk = iPID.substr(12, 1);
    var j = 0;
    var pidcut;
    for (var n = 0; n < 12; n++) {
      pidcut = parseInt(iPID.substr(j, 1));
      total = total + pidcut * (13 - n);
      j++;
    }

    chk = 11 - (total % 11);

    if (chk == 10) {
      chk = 0;
    } else if (chk == 11) {
      chk = 1;
    }
    if (chk == Validchk) {
      setErrorVaildateText({
        ...errorValidateText,
        cardId: "",
      });
      return true;
    } else {
      // $("#idcard").empty();
      // $("#idcard").addClass("is-invalid");
      // $("#idcard").focus();
      return false;
    }
  };
  const checkForm = async () => {
    let error = 0;
    setCardIdError("");
    if (!isEmpty(cardId)) {
      if (!checkCid(cardId)) {
        setCardIdError("กรุณาระบุเลขที่บัตรประจำตัวประชาชนให้ถูกต้อง");
        error = error + 1;
      }
    } else {
      setCardIdError("กรุณาระบุเลขที่บัตรประจำตัวประชาชน");
      error = error + 1;
    }
    if (aeCode.length > 0 && aeCode.length < 4) {
      error = error + 1;
      setAeCodeError("กรุณาระบุ AE CODE ให้ถูกต้อง");
    }

    if (isEmpty(f0_mobile_phone) || f0_mobile_phone.length < 10) {
      error = error + 1;
      setMobilePhoneError("กรุณาระบุเบอร์โทรศัพท์มือถือ");
    }
    var cleaned = ("" + f0_mobile_phone).replace(/\D/g, "");
    var match_mobile_phone = cleaned.match(/^0[0-9]{9}$/);
    if (!match_mobile_phone) {
      setMobilePhoneError("กรุณาระบุเบอร์โทรศัพท์มือถือให้ถูกต้อง");
      error = error + 1;
    }
    setEmailError("");
    if (isEmpty(f0_email)) {
      setEmailError("กรุณาระบุอีเมล");
      error = error + 1;
    } else {
      if (!f0_email.match(mailformat)) {
        setEmailError("กรุณาระบุอีเมลให้ถูกต้อง");
        error = error + 1;
      } else {
        setEmailError("");
      }
    }
    setEmailError1("");
    if (isEmpty(f0_email_1)) {
      setEmailError1("กรุณาระบุยืนยันอีเมล");
      error = error + 1;
    } else {
      if (!f0_email_1.match(mailformat)) {
        setEmailError1("กรุณาระบุยืนยันอีเมลให้ถูกต้อง");
        error = error + 1;
      } else {
        if (f0_email !== f0_email_1) {
          setEmailError1("อีเมลไม่ตรงกัน โปรดตรวจสอบอีเมล");
          error = error + 1;
        } else {
          setEmailError1("");
        }
      }
    }
    return error;
  };
  const formatCid = (input) => {
    setIscheckIdcard(true);
    if (!input || input.length < 13) return input;
    return input.replace(
      /(\d{1})(\d{4})(\d{5})(\d{2})(\d{1})/,
      "$1-$2-$3-$4-$5",
    );
  };
  const [tempHeaderManp, setTempHeaderManp] = useState("");
  const handleNext = async () => {
    if (!isSubmit) {
      setIsSubmit(true);
    }
    let error = await checkForm();
    if (error === 0) {
      setIsLoading(true);
      const comebackWithOtp = getData("comebackWithOtp");
      let card_id = cardId.replace(/[-]+/g, "");
      if (comebackWithOtp) {
        const old_data = getData("old_data") ? getData("old_data") : "";
        if (old_data.checkuserinfo.cardId !== card_id) {
          // console.log("remove header cardId change");
          const HeaderManp = getData("HeaderManp");
          const { head_token } = HeaderManp;
          var keys_lock = [
            "_secure__ls__metadata",
            "lang",
            "api_error",
            "Translations",
            "aecode",
            "checkuserinfo",
          ];
          var keys = Object.keys(localStorage),
            i = keys.length;
          while (i--) {
            if (!keys_lock.includes(keys[i])) {
              clearData(keys[i]);
            }
          }
          try {
            await GlobalApi.post(
              `${Configs.baseAPIURL03}/form/header/removeheader`,
              qs.stringify({
                head_token,
              }),
            )
              .then(async (res) => {
                setIsLoading(false);
                if (res.data.Data[0][0].IsSuccess === 1) {
                  await clearImage(head_token);
                  await clearData("HeaderManp");
                  await storeData("checkuserinfo", {
                    cardId: card_id,
                    f0_mobile_phone: f0_mobile_phone,
                    f0_email: f0_email,
                    f0_email_1: f0_email_1,
                    aeCode: haveAeCode ? aeCode : "",
                  });
                  await props.history.push("/questions");
                } else {
                  setIsModalError(true);
                }
              })
              .catch((er) => {
                // console.log(er);
                setIsLoading(false);
                setIsModalError(true);
              });
          } catch (error) {
            // console.log(error);
            setIsLoading(false);
            setIsModalError(true);
          }
        } else {
          // console.log("comebackWithOtp");
          var postData = {
            card_id: card_id,
            mobile_number: f0_mobile_phone,
            aecode: haveAeCode ? aeCode : "",
            email: f0_email,
          };
          checkCustomer(postData);
        }
      } else {
        var postData = {
          card_id: card_id,
          mobile_number: f0_mobile_phone,
          aecode: haveAeCode ? aeCode : "",
          email: f0_email,
        };
        storeData("checkuserinfo", {
          cardId: card_id,
          f0_mobile_phone: f0_mobile_phone,
          f0_email: f0_email,
          f0_email_1: f0_email_1,
          aeCode: haveAeCode ? aeCode : "",
        });
        setIsLoading(true);
        checkCustomer(postData);
        //////
      }
    } else {
      return false;
    }
    //TODO function nextPage
  };

  const checkCustomer = async (postData) => {
    try {
      await GlobalApi.post(
        `${Configs.baseAPIURL03}/form/header/checkcustomer`,
        qs.stringify(postData),
      )
        .then(async (res) => {
          // 000 : Success
          // 011 : ข้อมูลเจ้าหน้าที่การตลาดไม่ถูกต้อง
          // 012 : ท่านมีบัญชีอยู่แล้ว หากต้องการสอบถามข้อมูลกรุณาติดต่อผู้แนะนำการลงทุนหรือฝ่ายบริการลูกค้า
          // 021 : เบอร์โทรศัพท์มือถือ และ/หรืออีเมล ที่ท่านระบุ ซ้ำกับฐานข้อมูล KTBST SEC กรุณากรอกข้อมูลใหม่ หรือติดต่อฝ่ายบริการลูกค้า
          // 022 : Your CardId is found in sanction list
          if (res.data.Data[0][0].IsSuccess === 1) {
            const ic = {
              ICName: res.data.Data[0][0].ICName,
              ICTel: res.data.Data[0][0].ICTel,
              AECode: aeCode,
            };
            await storeData("dipchip_ic", dipChip);
            await storeData("current_ic", ic);
            if (res.data.Data[0][0].ValidateCode === "000") {
              // อยู่ระหว่างเปิดบัญชี
              try {
                await GlobalApi.post(
                  `${Configs.baseAPIURL03}/form/comeback/selbyhead`,
                  qs.stringify(postData),
                )
                  .then(async (res) => {
                    setIsLoading(false);
                    let comeback = res.data.Data[0][0].comeback;
                    let last_stamp = res.data.Data[0][0].last_stamp;
                    const HeaderManp = res.data.Data[0][0];
                    if (!isEmpty(HeaderManp) && isNil(HeaderManp.head_token)) {
                      clearData("HeaderManp");
                    }

                    if (comeback !== undefined) {
                      //มีบัญชีแล้ว
                      if (comeback) {
                        await setTempHeaderManp(HeaderManp);
                        await storeData("HeaderManp", HeaderManp);
                        await setIsModal(true);
                      } else {
                        let card_id = cardId.replace(/[-]+/g, "");
                        var checkuserinfo = {
                          cardId: card_id,
                          f0_mobile_phone: f0_mobile_phone,
                          f0_email: f0_email,
                          f0_email_1: f0_email_1,
                          aeCode: aeCode,
                        };
                        storeData("checkuserinfo", checkuserinfo);
                        props.history.push("/questions");
                      }
                    } else {
                      setIsModal(true);
                    }
                  })
                  .catch((er) => {
                    // console.log(er);
                    var mss = modalErrorDes;
                    var title_mss = modalErrorTitle;
                    if (!!er.isAxiosError && !er.response) {
                      title_mss = "เกิดข้อผิดพลาด";
                      mss = "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง";
                    } else {
                      title_mss =
                        er.response.data.Data !== undefined &&
                        er.response.data.Data[0][0].MsgDescTitle !== ""
                          ? er.response.data.Data[0][0].MsgDescTitle
                          : "เกิดข้อผิดพลาด";
                      mss =
                        er.response.data.Data !== undefined &&
                        er.response.data.Data[0][0].MsgDesc !== ""
                          ? er.response.data.Data[0][0].MsgDesc
                          : "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง";
                    }
                    setIsLoading(false);
                    setIsModalError(true);
                    setModalErrorTitle(title_mss);
                    setModalErrorDes(mss);
                  });
              } catch (error) {
                // console.log(error);
                var title_mss = "เกิดข้อผิดพลาด";
                var mss = "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง";
                setIsLoading(false);
                setIsModalError(true);
                setModalErrorTitle(title_mss);
                setModalErrorDes(mss);
              }
              return;
            } else {
              setModalErrorTitle("เกิดข้อผิดพลาด");
              setModalErrorDes(
                "ขออภัยท่านไม่สามารถทำรายการได้ กรุณาติดต่อ DAOL Contact Center 0 2351 1800",
              );
              setIsModalError(true);
            }
          } else if (
            res.data.Data[0][0].IsSuccess === "0" ||
            res.data.Data[0][0].IsSuccess === 0
          ) {
            setIsLoading(false);
            if (res.data.Data[0][0].ValidateCode === "011") {
              setModalErrorTitle("เกิดข้อผิดพลาด");
              setModalErrorDes(res.data.Data[0][0].MsgDesc);
              setIsModalError(true);
            } else if (res.data.Data[0][0].ValidateCode === "012") {
              setIsModalHaveAccount(true);
            } else if (res.data.Data[0][0].ValidateCode === "021") {
              setModalErrorTitle("เกิดข้อผิดพลาด");
              setModalErrorDes(res.data.Data[0][0].MsgDesc);
              setIsModalError(true);
            } else {
              setModalErrorTitle("เกิดข้อผิดพลาด");
              setModalErrorDes(
                "ขออภัยท่านไม่สามารถทำรายการได้ กรุณาติดต่อ DAOL Contact Center 0 2351 1800",
              );
              setIsModalError(true);
            }
          }
          return;
        })
        .catch((error) => {
          setIsLoading(false);
        });
    } catch (error) {
      // console.log(error);
      setIsLoading(false);
    }
  };

  const popUps = async (val) => {
    setIsLoading(true);
    let HeaderManp = getData("HeaderManp");
    if (isEmpty(HeaderManp)) {
      HeaderManp = tempHeaderManp;
    }
    const { head_token, last_stamp, token } = HeaderManp;
    if (!isEmpty(HeaderManp.head_token)) {
      if (val) {
        setIsLoading(true);
        try {
          await GlobalApi.post(
            `${Configs.baseAPIURL03}/form/header/removeheader`,
            qs.stringify({
              head_token,
            }),
          )
            .then(async (res) => {
              setIsLoading(false);
              if (res.data.Data[0][0].IsSuccess === 1) {
                await clearImage(head_token);
                await clearData("HeaderManp");
                await props.history.push("/questions");
              } else {
                setIsModalError(true);
              }
            })
            .catch((er) => {
              // console.log(er);
              setIsLoading(false);
              setIsModalError(true);
            });
        } catch (error) {
          // console.log(error);
          setIsLoading(false);
          setIsModalError(true);
        }
      } else {
        await storeData("HeaderManp", {
          head_token: head_token,
          token: token,
        });
        let card_id = cardId.replace(/[-]+/g, "");
        const data = { id_card: card_id, aecode: aeCode ? aeCode : "null" };
        storeData("stamp_page", "ekyc");

        await checkDipChipStatus(head_token, data);
        await storeData("last_stamp", last_stamp);
        await call_axios2UpdateCheckinfo();
        return;
      }
    } else {
      props.history.push("/questions");
      // console.log("don't have HeaderManp and go to questions");
    }
    return;
  };
  const checkEkycVerify = async (head_token, info) => {
    setIsLoading(true);
    const header = {
      headers: {
        Accept: "application/json",
      },
    };
    const data = {
      head_token: head_token,
      id_card: info?.id_card,
    };
    try {
      const res = await GlobalApi.post(
        `${Configs.baseAPIURL03}/form/ekyc/verify`,
        data,
        header,
      );
      if (res?.data?.Data?.[0]?.IsSuccess !== 0) {
        const EkycChannel = res?.data?.Data?.[0]?.Data?.[0]?.EkycChannel;
        const ekycFlags = {
          DIPCHIP: "pass_dipchip",
          NDID: "pass_ndid",
          THAID: "pass_ThaID",
        };
        console.log(ekycFlags[EkycChannel]);

        if (ekycFlags[EkycChannel]) {
          storeData(ekycFlags[EkycChannel], true);
        }
      }
    } catch (error) {
      setIsLoading(false);

      let title_mss = "เกิดข้อผิดพลาด";
      let mss = "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง";

      if (!!error.isAxiosError && !error.response) {
        // Keep default message
      } else if (error.response?.data?.Data?.[0]?.[0]) {
        const errData = error.response.data.Data[0][0];
        title_mss = errData.MsgDescTitle || title_mss;
        mss = errData.MsgDesc || mss;
      }

      setModalErrorTitle(title_mss);
      setModalErrorDes(mss);
      setIsModalError(true);
    }
  };

  const checkDipChipStatus = async (head_token, data) => {
    const saveData = [
      {
        name: "dipchip_status",
        url: `${Configs.baseAPIURL03}/form/dipchip_status/selbyhead`,
        postData: {
          head_token: head_token,
          id_card: data?.id_card,
          ae_code: data?.aecode,
        },
      },
    ];
    try {
      await GlobalApi.post(saveData[0].url, saveData[0].postData, header)
        .then(async (res) => {
          if (res?.data?.Data?.[0]?.IsSuccess === 1) {
            const dipchipData = res?.data?.Data?.[0].Data?.[0];
            await saveDipchip(dipchipData, head_token, data);
          } else {
            await checkEkycVerify(head_token, data);
          }
        })
        .catch((err) => {
          throw err;
        });
    } catch (error) {
      throw error;
    }
  };
  const saveDipchip = async (dipchipData, head_token, data) => {
    try {
      const complete_date = moment(
        dipchipData.SAfdp_CompleteDate?.date,
        "YYYY-MM-DD HH:mm:ss.SSSSSS",
      );
      const saveData = [
        {
          name: "dipchip_status",
          url: `${Configs.baseAPIURL03}/form/dipchip/manp`,
          postData: {
            head_token: head_token,
            id_card: data?.id_card,
            ae_code: data?.aecode,
            firstname: dipchipData.SAfdp_FirstName,
            lastname: dipchipData.SAfdp_LastName,
            middlename: dipchipData.SAfdp_MiddleName,
            birthday: dipchipData.SAfdp_Birthday,
            respose_code: dipchipData.SAfdp_ResposeCode,
            respose_desc: dipchipData.SAfdp_ResposeDesc,
            is_error: dipchipData.SAfdp_IsError,
            complete_date: complete_date.format("YYYY-MM-DD HH:mm:ss.SSS"),
            channel: "OA",
            mkt_remark: dipchipData.SAfdp_MKTRemark,
            doc_ref1: dipchipData.SAfdp_Doc_ref1,
            doc_ref2: dipchipData.SAfdp_Doc_ref2,
          },
        },
      ];
      await GlobalApi.post(saveData[0].url, saveData[0].postData, header)
        .then(async (res) => {
          if (res?.data?.Data?.[0]?.IsSuccess === 1) {
            storeData("pass_dipchip", true);
            var stamp_page = getData("stamp_page");
            if (stamp_page === "SUMMARY") {
              saveComeback("CONFIRM", head_token);
            }
          } else {
            storeData("pass_dipchip", false);
          }
        })
        .catch((err) => {
          throw err;
        });
    } catch (error) {
      throw error;
    }
  };
  const saveComeback = async (type, head_token) => {
    storeData("stamp_page", type);
    var last_stamp = JSON.stringify(await getAllStorage(type));
    const saveData = [
      {
        name: "comeback",
        url: `${Configs.baseAPIURL03}/form/comeback/manp`,
        postData: {
          head_token: head_token,
          last_stamp: last_stamp,
          stamp_page: type,
        },
      },
    ];
    try {
      await GlobalApi.post(
        saveData[0].url,
        qs.stringify(saveData[0].postData),
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Accept: "application/json",
          },
        },
      )
        .then((res) => {
          if (res?.data?.Data?.[0]?.[0]?.IsSuccess === 1) {
            // type === "EKYC" ? storeData("pass_dipchip", false) : type === "CONFIRM" ? storeData("pass_dipchip", true) : "";
          }
        })
        .catch((er) => {
          throw er;
        });
    } catch (error) {
      throw error;
    }
  };
  const call_axios2UpdateCheckinfo = async (comeback) => {
    setIsLoading(true);
    const comebackWithOtp = getData("comebackWithOtp");
    if (comebackWithOtp) {
      props.history.push("/questions");
    } else {
      const HeaderManp = getData("HeaderManp");
      const { head_token } = HeaderManp;
      if (isEmpty(HeaderManp.last_stamp)) {
        await storeData("last_stamp", tempHeaderManp.last_stamp);
      }
      var postData = {
        head_token,
        f1_mobile: f0_mobile_phone,
        f1_email: f0_email,
        f1_investment_consultant_id: aeCode,
      };
      try {
        GlobalApi.post(
          `${Configs.baseAPIURL03}/form/header_info/manp`,
          qs.stringify(postData),
        )
          .then(async (res) => {
            if (res.data.Data[0][0].IsSuccess === 0) {
              setIsLoading(false);
              if (res.data.Data[0][0].MsgDesc !== "") {
                setModalErrorTitle("เกิดข้อผิดพลาด");
                setModalErrorDes(
                  res.data.Data[0][0].MsgDesc
                    ? res.data.Data[0][0].MsgDesc
                    : "ขออภัยท่านไม่สามารถทำรายการได้ กรุณาติดต่อ DAOL Contact Center 0 2351 1800",
                );
                setIsModalError(true);
              } else {
                setModalErrorTitle("เกิดข้อผิดพลาด");
                setModalErrorDes("กรุณา ลองใหม่ / please try again");
                setIsModalError(true);
              }
              return false;
            } else {
              if (isEmpty(getData("last_stamp"))) {
                await storeData("last_stamp", tempHeaderManp.last_stamp);
              }
              await clearData("first_otp");
              props.history.push("/otp");
              setIsLoading(false);
            }
          })
          .catch((er) => {
            // console.log(er);
            var mss = modalErrorDes;
            var title_mss = modalErrorTitle;
            if (!!er.isAxiosError && !er.response) {
              title_mss = "เกิดข้อผิดพลาด";
              mss = "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง";
            } else {
              title_mss =
                er.response.data.Data !== undefined &&
                er.response.data.Data[0][0].MsgDescTitle !== ""
                  ? er.response.data.Data[0][0].MsgDescTitle
                  : "เกิดข้อผิดพลาด";
              mss =
                er.response.data.Data !== undefined &&
                er.response.data.Data[0][0].MsgDesc !== ""
                  ? er.response.data.Data[0][0].MsgDesc
                  : "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง";
            }
            setIsLoading(false);
            setIsModalError(true);
            setModalErrorTitle(title_mss);
            setModalErrorDes(mss);
          });
      } catch (error) {
        setModalErrorTitle("เกิดข้อผิดพลาด");
        setModalErrorDes(
          "ขออภัยท่านไม่สามารถทำรายการได้ กรุณาติดต่อ DAOL Contact Center 0 2351 1800",
        );
        setIsModalError(true);
      }
    }
  };
  const popUpHaveAccount = async (val) => {
    if (val) {
      setIsLoading(true);
      let card_id = cardId.replace(/[-]+/g, "");
      const data = { id_card: card_id, aecode: aeCode ? aeCode : "null" };
      try {
        GlobalApi.post(
          `${Configs.baseAPIURL03}/form/current_sso/selbyidentity`,
          data,
          header,
        )
          .then((res) => {
            if (parseInt(res.data.Data[0].IsMember) === 0) {
              window.location = Configs.baseLINKLIFE + "/Registration";
            } else if (parseInt(res.data.Data[0].IsMember) === 1) {
              window.location = Configs.baseLINKLIFE + "/Login";
            }
          })
          .catch((er) => {
            setIsLoading(false);
            // console.log(er);
            var mss = modalErrorDes;
            var title_mss = modalErrorTitle;
            if (!!er.isAxiosError && !er.response) {
              title_mss = "เกิดข้อผิดพลาด";
              mss = "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง";
            } else {
              title_mss =
                er.response.data.Data !== undefined &&
                er.response.data.Data[0][0].MsgDescTitle !== ""
                  ? er.response.data.Data[0][0].MsgDescTitle
                  : "เกิดข้อผิดพลาด";
              mss =
                er.response.data.Data !== undefined &&
                er.response.data.Data[0][0].MsgDesc !== ""
                  ? er.response.data.Data[0][0].MsgDesc
                  : "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง";
            }
            setIsLoading(false);
            setIsModalError(true);
            setModalErrorTitle(title_mss);
            setModalErrorDes(mss);
          });
      } catch (error) {
        setIsLoading(false);
        setModalErrorTitle("เกิดข้อผิดพลาด");
        setModalErrorDes(
          "ขออภัยท่านไม่สามารถทำรายการได้ กรุณาติดต่อ DAOL Contact Center 0 2351 1800",
        );
        setIsModalError(true);
      }
    } else {
      setIsModalHaveAccount(false);
    }
  };
  const checkBackToIndex = () => {
    storeData("HaveAe", true);
    props.history.push("/");
  };
  const clearImage = async (head_token) => {
    const header = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Accept: "application/json",
      },
    };
    try {
      var postData = {
        head_token,
      };
      await GlobalApi.post(
        `${Configs.baseURL}/api/clearupload`,
        qs.stringify(postData),
        header,
      )
        .then(async (res) => {
          setIsLoading(false);
        })
        .catch((er) => {
          // console.log(er);
          setIsLoading(false);
          let title = "เกิดข้อผิดพลาด";
          let mss =
            "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง <br>(" +
            getData("api_error")?.message +
            ")";
          setIsModalError(true);
          setModalErrorTitle(title);
          setModalErrorDes(mss);
        });
    } catch (error) {
      // console.log(error);
      setIsLoading(false);
      let title = "เกิดข้อผิดพลาด";
      let mss =
        "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง <br>(" +
        getData("api_error")?.message +
        ")";
      setIsModalError(true);
      setModalErrorTitle(title);
      setModalErrorDes(mss);
    }
    return;
  };
  const checkDipchip = async (cardId) => {
    setIsLoading(true);
    const HeaderManp = getData("HeaderManp");
    const { head_token } = HeaderManp;
    const saveData = [
      {
        name: "dipchip_status",
        url: `${Configs.baseAPIURL03}/form/dipchip_status/selbyhead`,
        postData: {
          head_token: head_token ? head_token : "",
          id_card: cardId.replace(/-/g, ""),
          ae_code: "All",
        },
      },
    ];
    try {
      await GlobalApi.post(saveData[0].url, saveData[0].postData, header)
        .then(async (res) => {
          setIsLoading(false);
          console.log(res.data.Data[0].Data);
          const data = res.data.Data[0].Data;
          let ic = "";
          data?.map((row, i) => {
            ic += row.AECode.toUpperCase() + (i < data.length - 1 ? " , " : ""); // ตรวจสอบให้แน่ใจว่ามีวงเล็บที่ถูกต้อง
          });
          setDipChip(ic);
        })
        .catch((er) => {
          console.log(er);
          setIsLoading(false);
        });
    } catch (error) {
      setIsLoading(false);
      setIsModalError(true);
    }
  };
  return (
    <>
      <HeaderPage
        title={translations?.[lang]?.checkuserinfo?.title}
        onChangeLang={(e) => setLang(e)}
        clickBack={(e) => (e ? checkBackToIndex() : "")}
      />
      <Loading status={isLoading} />
      <DialogCustoms
        open={isModal}
        isModel={setIsModal}
        switchType={(e) => popUps(e)}
        title={"ท่านอยู่ระหว่างการเปิดบัญชี"}
        btnPrimary={"กรอกข้อมูลใหม่"}
        btnSecondary={"ดำเนินการต่อ"}
      />
      <DialogCustom
        open={isModalHaveAccount}
        title={"ท่านมีบัญชี DAOL SEC อยู่แล้ว คลิก “เข้าสู่ระบบ” เพื่อ Login"}
        isModel={setIsModalHaveAccount}
        btnPrimary={"เข้าสู่ระบบ"}
        btnSecondary={"ปิด"}
        checkuserinfo={isMobile}
        switchType={(e) => {
          if (isMobile && e) {
            window.open(Configs.baseLINKLIFE + "/Login");
          } else {
            popUpHaveAccount(e);
          }
        }}
      />
      <DialogError
        open={isModalError}
        isModel={setIsModalError}
        title={modalErrorTitle}
        massage={modalErrorDes}
        btn={"ตกลง"}
      />
      <Grid className="background-bg">
        <Grid className="section-consent">
          <Grid className={isMobile ? "box-content-mb" : "box-content"}>
            <Grid container className="box-content-main" columns={16}>
              {!isMobile && (
                <Grid item xs={7} className="box-left">
                  <BoxLeftContent
                    clickBack={(e) => checkBackToIndex()}
                    translations={translations?.[lang]?.checkuserinfo}
                  />
                </Grid>
              )}
              <Grid
                item
                xs={isMobile ? 16 : 9}
                className={isMobile ? "box-right-mb" : "box-right"}
              >
                <Grid className="content">
                  <Grid className="content-main">
                    <Grid
                      className="box-right-content pb-3"
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        height: isMobile ? "100%" : "100%",
                      }}
                    >
                      <HeaderRight
                        title={translations?.[lang]?.checkuserinfo?.title}
                      />
                      <ScrollBarComponent
                        isCheck={isCheck}
                        onChangeCheck={setIscheck}
                        content={
                          <Box>
                            <Typography className="font-title">
                              ข้อมูลส่วนตัว
                            </Typography>

                            <Grid className="input-form">
                              <FormControl variant="standard" fullWidth error>
                                <TextField
                                  fullWidth
                                  className={"font-20"}
                                  label="เลขที่บัตรประจำตัวประชาชน"
                                  variant="standard"
                                  value={cardId || ""}
                                  onChange={(e) => cardIdChange(e.target.value)}
                                  required
                                  type="tel"
                                />
                              </FormControl>
                              <FormHelperText className="text-error">
                                {cardIdError}
                              </FormHelperText>
                              <br />
                              {dipChip && (
                                <Grid
                                  className="font-18 font-DBHeavent"
                                  style={{
                                    backgroundColor: "rgb(247, 248, 251)",
                                    padding: "20px",
                                  }}
                                >
                                  <Typography className="text-primary">
                                    ท่านเคยทำการเสียบบัตรประชาชน (Dip Chip)
                                    เพื่อยืนยันตัวตนกับ​เจ้าหน้าที่แนะนำการลงทุน
                                    (AE CODE)
                                  </Typography>
                                  <span>{dipChip}</span>
                                  <Typography className="text-primary">
                                    กรุณาระบุ AE CODE 4 ตัว ในช่อง
                                    ข้อมูลเจ้าหน้าที่แนะนำการลงทุน ด้านล่าง​
                                  </Typography>
                                </Grid>
                              )}
                            </Grid>

                            <Typography className="font-title">
                              ข้อมูลเจ้าหน้าที่แนะนำการลงทุน (ถ้ามี)
                            </Typography>

                            {haveAeCode ? (
                              <Grid className="input-form">
                                <FormControl variant="standard" fullWidth error>
                                  <TextField
                                    fullWidth
                                    label="AE CODE"
                                    value={aeCode || ""}
                                    onChange={(e) =>
                                      aeCodeChange(e.target.value)
                                    }
                                    disabled={getData("aecode") ? true : false}
                                    inputProps={{
                                      maxLength: 4,
                                      style: { textTransform: "uppercase" },
                                    }}
                                    margin="dense"
                                    helperText=""
                                    variant="standard"
                                  />
                                  <FormHelperText className="text-error">
                                    {aeCodeError}
                                  </FormHelperText>
                                </FormControl>
                              </Grid>
                            ) : (
                              ""
                            )}
                            <Typography className="font-title">
                              ข้อมูลการติดต่อ
                            </Typography>
                            <Grid className="input-form">
                              <PhoneInput
                                label={"เบอร์โทรศัพท์"}
                                inputProps={{
                                  required: true,
                                  autoFocus: true,
                                  readOnly: true,
                                }}
                                disabled
                                country={"th"}
                                value={value}
                                onChange={setValue}
                              />
                              <FormControl
                                variant="standard"
                                fullWidth
                                error
                                className={"input_tel"}
                              >
                                <TextField
                                  className={
                                    isMobile
                                      ? "input_tel_field"
                                      : "input_tel_field-d"
                                  }
                                  fullWidth
                                  label="เบอร์โทรศัพท์ *"
                                  value={f0_mobile_phone || ""}
                                  onChange={(e) =>
                                    mobilePhoneChange(e.target.value)
                                  }
                                  margin="dense"
                                  helperText=""
                                  variant="standard"
                                  inputProps={{
                                    maxLength: 10,
                                  }}
                                  type="tel"
                                />

                                <FormHelperText className="text-error">
                                  {mobilePhoneError}
                                </FormHelperText>
                              </FormControl>
                              {!mobilePhoneError && (
                                <Grid className="font-20 font-DBHeavent">
                                  <span className="text-primary">ตัวอย่าง</span>
                                  &nbsp;
                                  <span>0861999999</span>
                                </Grid>
                              )}
                            </Grid>

                            <Grid className="input-form">
                              <FormControl variant="standard" fullWidth error>
                                <TextField
                                  fullWidth
                                  value={f0_email || ""}
                                  onChange={(e) => emailChange(e.target.value)}
                                  label="อีเมล *"
                                  margin="dense"
                                  helperText=""
                                  variant="standard"
                                />
                                <FormHelperText className="text-error">
                                  {emailError}
                                </FormHelperText>
                              </FormControl>
                            </Grid>

                            <Grid className="input-form">
                              <FormControl variant="standard" fullWidth error>
                                <TextField
                                  fullWidth
                                  value={f0_email_1 || ""}
                                  onChange={(e) => emailChange1(e.target.value)}
                                  label="ยืนยันอีเมล *"
                                  margin="dense"
                                  helperText=""
                                  variant="standard"
                                />
                                <FormHelperText className="text-error">
                                  {emailError1}
                                </FormHelperText>
                              </FormControl>
                            </Grid>
                          </Box>
                        }
                      ></ScrollBarComponent>
                      <ButtonRight
                        text={translations?.[lang]?.home?.next}
                        onNextPage={handleNext}
                        isDisbled={
                          cardId === "" ||
                          // (haveAeCode && aeCode === "") ||
                          (aeCode.length > 0 && aeCode.length < 4) ||
                          f0_mobile_phone === "" ||
                          f0_email === "" ||
                          f0_email_1 === ""
                        }
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};
export default memo(CheckUserInfo);
